import { render, staticRenderFns } from "./ParcelsOrdersList.vue?vue&type=template&id=451c9f72&scoped=true&"
import script from "./ParcelsOrdersList.vue?vue&type=script&lang=js&"
export * from "./ParcelsOrdersList.vue?vue&type=script&lang=js&"
import style0 from "./ParcelsOrdersList.vue?vue&type=style&index=0&id=451c9f72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451c9f72",
  null
  
)

export default component.exports